import { Customer, PaginatedResponse, User } from 'types/common_types';
import { createSlice } from '@reduxjs/toolkit';

interface customerState {
  customer_loading: boolean;
  customers: PaginatedResponse<Customer> | null;
  customer_detail: Customer | null;
  delete_loading: boolean;
}

const initialState: customerState = {
  customers: null,
  customer_detail: null,
  customer_loading: false,
  delete_loading: false,
};

export const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    setCustomerLoading: (state, action) => {
      state.customer_loading = action.payload;
    },
    setCustomers: (state, action) => {
      state.customers = action.payload;
    },
    setCustomerDetail: (state, action) => {
      state.customer_detail = action.payload;
    },
    setDeleteLoading: (state, action) => {
      state.delete_loading = action.payload;
    },
  },
});

export const { setCustomerLoading, setCustomers, setCustomerDetail, setDeleteLoading } = customerSlice.actions;

export default customerSlice.reducer;
